import React, { useCallback, useMemo } from 'react'

import DateRange from '../../../features/components/DateRange'
import ErrorMessage from '../../../components/Form/ErrorMessage'

import { getFormikFieldError } from '../../../helpers/errors'

import { END_DATE, START_DATE } from './fields'

const StartEndDateRangeFields = ({ formik, ...props }) => {
  const { errors, status, setValues, values, touched } = formik

  const startDate = values[START_DATE]
  const endDate = values[END_DATE]

  const dateRangeData = useMemo(() => {
    // object with startDate and endDate
    return { startDate, endDate }
  }, [startDate, endDate])

  const dateStartError = getFormikFieldError(errors, status, START_DATE).error
  const dateEndError = getFormikFieldError(errors, status, END_DATE).error

  const showErrorMessage = (touched[START_DATE] || touched[END_DATE]) && (dateStartError || dateEndError)

  const handleDateRangeChange = useCallback(
    rangeValues => {
      setValues({
        ...values,
        [START_DATE]: rangeValues.startDate,
        [END_DATE]: rangeValues.endDate
      })
    },
    [setValues, values]
  )

  return (
    // Don't remove this static className, we need it to select this component in DOM, and scroll to it.
    // We may need to scroll to this component when it has errors and is not in viewport.
    <div className="startEndDateRange">
      <DateRange onDateRangeChange={handleDateRangeChange} dateRangeData={dateRangeData} {...props} />
      {showErrorMessage && <ErrorMessage error="Please select start and end date" />}
    </div>
  )
}

export default StartEndDateRangeFields
